import en from './customers.en';

const enConfig = { en };

export default enConfig;
